import httpClient from 'src/axios';
import {
  REGISTER,
  LOGIN,
  GET_USER_INFO,
  POST_USER_INFO,
  SEND_REGISTER_OTP,
  SEND_LOGIN_OTP,
  CONFIRM_REGISTER_OTP,
  SET_NEW_PASSWORD,
  GET_SUGGESTED_PLAN_DETAILS,
  SET_USER_PASSWORD_AND_BASIC_INFO,
  GET_PLAN,
  RESET_PASSWORD_OTP,
  RESET_PASSWORD_CONFIRM_OTP,
  RESEND_RESET_PASSWORD_OTP,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  SEND_CHANGE_PASSWORD_OTP,
  POST_FINANCIAL_INFO,
  POST_CONTACT_INFO,
  GET_PROVINCE_LIST,
  GET_CITY_LIST,
  GET_USER_CONTACT_INFO,
  GET_USER_FINANCIAL_INFO,
  GET_USER_DOCUMENTS,
  GET_IMAGE,
  GET_ACCOUNT_INFO,
  FINISH_REGISTRATION,
  REQUEST_PORTFOLIO,
  CONTACT_US,
  GET_BANK_LIST,
  GET_CAPTCHA,
  SEND_SEJAM_OTP,
  SEJAM_SAVE_PROFILE,
  CITIES_AUTOCOMPLETE,
  GET_USER_ACTION_LOG,
  GET_USER_TICKET,
  REMOVE_DOCUMENT,
  GET_TICKET,
  SEND_TICKET,
  SEND_TICKET_RESPONSE,
  GET_TICKET_CATEGORIES,
  GET_TICKET_FILE,
  SEND_TICKET_REPLY_RESPONSE,
  GET_USER_SETTINGS,
  CHANGE_USER_SETTINGS,
  SEND_ACTION_OTP,
  REVOKE_TOKEN,
  SET_DEFAULT_FINANCIAL,
  UPDATE_FINANCIAL_INFO,
  ACCOUNT_CAPTCHA,
  GET_USER_ALL_INFO,
  GET_LICENSE_CAPTCHA,
  LICENSE_OTP,
  CONFIRM_LICENSE_OTP,
  RESEND_TWO_FACTOR_SMS,
  RESEND_REGISTER_OTP,
  CHECK_USER_REGISTRATION_DATA,
  CHANGE_PROFIT_TYPE,
  SEND_CHANGE_ACCOUNT_SECURITY_OTP,
  CHANGE_SECURITY_STATUS,
  LOG_OUT,
  CONFIRM_LOGIN_OTP,
  GET_CURRENT_SESSIONS,
  GET_OTHER_SESSIONS,
  TERMINATE_OTHER_SESSIONS,
  GET_SESSION_INFO,
  FEATURE_FLAG,
  EDIT_PROFILE,
  SEND_OTP_REGISTER_BY_NATIONAL_ID,
  CONFIRM_OTP_REGISTER_BY_NATIONAL_ID,
  RESEND_OTP_REGISTER_BY_NATIONAL_ID,
  RESEND_LOGIN_OTP,
} from 'src/endpoints'


// const getAllUsers = () => httpClient.get(END_POINT);

// // you can pass arguments to use as request parameters/data
// const getUser = (user_id) => httpClient.get(END_POINT, { user_id });
// // maybe more than one..
const register = (payload) => httpClient.post(REGISTER, {
  phoneOrEmail: payload.phoneOrEmail,
  password: payload.password,
  confirmPassword: payload.confirmPassword,
  captchaKey: payload.captchaKey,
  captchaValue: payload.captchaValue
});

const login = (payload) => httpClient.post(LOGIN, {
  phoneOrEmail: payload.phoneOrEmail,
  password: payload.password,
  scope: 'user',
  captchaKey: payload.captchaKey,
  captchaValue: payload.captchaValue,
  nationalId:payload.nationalId
// }, {withCredentials: true});
});

const getUserSettings = () => httpClient.get(GET_USER_SETTINGS);

const changeUserSettings = (payload) => httpClient.get(CHANGE_USER_SETTINGS(payload));

const sendActionOtp = () => httpClient.post(SEND_ACTION_OTP);
const revokeToken = (payload) =>
  httpClient.post(REVOKE_TOKEN, {
    userId: payload.userId,
    refreshToken: payload.refreshToken,
    scope: payload.scope
  }, { skipAuthRefresh: true })

const getUserInfo = () => httpClient.get(GET_USER_INFO);

const getUserContactInfo = () => httpClient.get(GET_USER_CONTACT_INFO);

const getUserFinancialInfo = () => httpClient.get(GET_USER_FINANCIAL_INFO);

const getSuggestedPlanDescription = (payload) => httpClient.get(GET_SUGGESTED_PLAN_DETAILS(payload));

const getPlan = (payload) => httpClient.get(GET_PLAN(payload.slug));

const getUserDocuments = () => httpClient.get(GET_USER_DOCUMENTS);

const getImage = (payload) => httpClient.get(GET_IMAGE(payload.path), {
  responseType: "arraybuffer",
});

const getProvinceList = () => httpClient.get(GET_PROVINCE_LIST)

const getBanksList = () => httpClient.get(GET_BANK_LIST)

const getCityList = (payload) => httpClient.get(GET_CITY_LIST(payload.provinceId))

const citiesAutoComplete = (payload) => httpClient.get(CITIES_AUTOCOMPLETE(payload))

const requestPortfolio = (payload) => httpClient.post(REQUEST_PORTFOLIO, {
  name: payload.name,
  note: payload.note,
  family: payload.family,
  email: payload.email,
  cityId: payload.cityId,
  phoneNumber: payload.phoneNumber,
  minInvest: payload.minInvest,
  maxInvest: payload.maxInvest
});

const contactUs = (payload) => httpClient.post(CONTACT_US, {
  userFullName: payload.userFullName,
  subject: payload.subject,
  body: payload.body,
  phoneOrEmail: payload.phoneOrEmail,
});


const postUserInfo = (payload) => httpClient.post(POST_USER_INFO, {
  name: payload.name,
  sex: payload.sex,
  family: payload.family,
  nationalId: payload.nationalId,
  birthDate: payload.birthDate,
  fatherName: payload.fatherName,
  birthCertificateNo: payload.birthCertificateNo,
  investmentMin: payload.investmentMin,
  investmentMax: payload.investmentMax,
  issuePlaceBirthCertification: payload.issuePlaceBirthCertification,
  birthCertificationSerialNumber: payload.birthCertificationSerialNumber,
});

const postFinancialUserInfo = (payload) => httpClient.post(POST_FINANCIAL_INFO, {
  bankId: payload.bankId,
  branchName: payload.branchName,
  bankCityName: payload.bankCityName,
  bankBranchCode: payload.bankBranchCode,
  accountType: payload.accountType,
  shabaNumber: payload.shabaNumber,
  accountNumber: payload.accountNumber,
});

const updateFinancialUserInfo = (payload) => httpClient.post(UPDATE_FINANCIAL_INFO, {
  financialInfoId:payload.id,
  bankId: payload.bankId,
  branchName: payload.branchName,
  bankCityName: payload.bankCityName,
  bankBranchCode: payload.bankBranchCode,
  accountType: payload.accountType,
  shabaNumber: payload.shabaNumber,
  accountNumber: payload.accountNumber,
});

const setDefaultFinancial = (financialInfoId) => httpClient.put(SET_DEFAULT_FINANCIAL(financialInfoId));

const postContactInfo = (payload) => httpClient.post(POST_CONTACT_INFO, {
  cityId: payload.city,
  telephone: payload.telephone,
  postalCode: payload.postalCode,
  emailAddress: payload.emailAddress,
  address: payload.address
});

const sendRegisterOtp = (payload) => httpClient.post(SEND_REGISTER_OTP, {
  phoneOrEmail: payload.phoneOrEmail,
  captchaKey: payload.captchaKey,
  captchaValue: payload.captchaValue
});

const sendLoginOtp = (payload) => httpClient.post(SEND_LOGIN_OTP,{
  "phoneOrEmail": payload.phoneOrEmail,
  "nationalId": payload.nationalId,
  "captchaKey": payload.captchaKey,
  "captchaValue": payload.captchaValue
});

const confirmOtp = (payload) => httpClient.post(CONFIRM_REGISTER_OTP, {
  phoneOrEmail: payload.phoneOrEmail,
  scope: 'user',
  confirmationCode: payload.confirmationCode
});

const confirmLoginOtp = (payload) => httpClient.post(CONFIRM_LOGIN_OTP, {
    phoneOrEmail: payload.phoneOrEmail,
    confirmationCode: payload.confirmationCode,
    scope: 'user',
    nationalId:payload.nationalId
  })

const setNewPassword = (payload) => httpClient.post(SET_NEW_PASSWORD, payload.password);

const setUserPasswordAndBasicInfo = ({
  newPassword,
  name,
  family,
  verification
}) => httpClient.post(SET_USER_PASSWORD_AND_BASIC_INFO, {
  registerationPassportToken: verification,
  name: name,
  family: family,
  password: newPassword,
  scope: 'user'
});

const resetPasswordOtp = ({ phoneOrEmail, captchaKey, captchaValue,nationalId }) => httpClient.post(RESET_PASSWORD_OTP, {
  phoneOrEmail,
  captchaKey,
  captchaValue,
  nationalId
});

const resetPasswordConfirmOtp = (payload) => httpClient.post(RESET_PASSWORD_CONFIRM_OTP, {
  phoneOrEmail: payload.phoneOrEmail,
  otp: payload.otp,
  nationalId:payload.nationalId
});

const resendResetPasswordOtp = (payload) => httpClient.post(RESEND_RESET_PASSWORD_OTP, {
  phoneOrEmail: payload.phoneOrEmail,
  passportToken: payload.passportToken,
  nationalId:payload.nationalId
});

const resetPassword = (payload) => httpClient.post(RESET_PASSWORD, {
  passportToken: payload.passportToken,
  phoneOrEmail: payload.phoneOrEmail,
  newPassword: payload.newPassword,
  confirmNewPassword: payload.confirmNewPassword,
  nationalId:payload.nationalId
});

const changePassword = ({
  oldPassword,
  newPassword,
  newPasswordConfirmed,
  otp
}) => httpClient.post(CHANGE_PASSWORD, {
  oldPassword: oldPassword,
  newPassword: newPassword,
  newPasswordConfirmed: newPasswordConfirmed,
  otp
});


const sendChangePasswordOtp = () => httpClient.post(SEND_CHANGE_PASSWORD_OTP);

const getAccountInfo = () => httpClient.get(GET_ACCOUNT_INFO);

const finishRegistration = () => httpClient.post(FINISH_REGISTRATION);

const checkUserRegistrationData = () => httpClient.post(CHECK_USER_REGISTRATION_DATA);

const getCaptcha = (payload) => {
  return httpClient.get(GET_CAPTCHA(payload));
}

const getAccountCaptcha = (payload) => {
  return httpClient.get(ACCOUNT_CAPTCHA(payload));
}

const sendSejamOtp = (payload) => httpClient.post(SEND_SEJAM_OTP, {
  nationalId: payload.nationalId,
  captchaKey: payload.captchaKey,
  captchaValue: payload.captchaValue
});

const getLicenseCaptcha = (payload) => {
  return httpClient.get(GET_LICENSE_CAPTCHA(payload));
}

const saveSejamProfile = (payload) => httpClient.post(SEJAM_SAVE_PROFILE, {
  nationalId: payload.nationalId,
  otpCode: payload.otpCode
});

const removeDocument = (payload) => httpClient.delete(REMOVE_DOCUMENT(payload.documentType));

const getUserActionLog = (payload) => httpClient.get(GET_USER_ACTION_LOG(payload))

const getUserTicket = (payload) => httpClient.get(GET_USER_TICKET(payload));


const getTicket = (payload) => httpClient.get(GET_TICKET(payload.ticketId));

const sendTicket = (file) => httpClient.post(SEND_TICKET, file);

const sendTicketResponse = (file) => httpClient.post(SEND_TICKET_RESPONSE, file, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
const sendTicketReplyResponse = (payload, file) => httpClient.post(SEND_TICKET_REPLY_RESPONSE(payload), file, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

const getTicketCategories = () => httpClient.get(GET_TICKET_CATEGORIES());

const getTicketFile = (payload) => httpClient.get(GET_TICKET_FILE(payload), {
  responseType: 'arraybuffer',
  headers: {
    'Accept': 'application/octet-stream',
  },
});

const getUserAllInfo = (userId) => httpClient.get(GET_USER_ALL_INFO(userId));

const licenseOtp = (payload) => httpClient.post(LICENSE_OTP, payload)

const confirmLicenseOtp = (code) => httpClient.post(CONFIRM_LICENSE_OTP, code)

const resendRegisterOtp = (payload) => httpClient.post(RESEND_REGISTER_OTP, payload)

const resendTwoFactorSms = (phone) => httpClient.post(RESEND_TWO_FACTOR_SMS, phone)

const changeProfitType = ({
  fundId,
  rate,
  profitType
}) => httpClient.post(CHANGE_PROFIT_TYPE, {
  fundId: fundId,
  profitRate: rate,
  profitType: profitType
})

const sendChangeAccountSecurityOtp = () => httpClient.post(SEND_CHANGE_ACCOUNT_SECURITY_OTP)

const changeAccountSecurity = ({
  value,
  confirmationCode
}) => httpClient.post(CHANGE_SECURITY_STATUS, {
  value: value,
  confirmationCode: confirmationCode
})

const logout = (refreshToken) => httpClient.post(LOG_OUT, refreshToken)

const getCurrentSessions = (refreshToken) => httpClient.post(GET_CURRENT_SESSIONS, {refreshToken: refreshToken})

const getOtherSessions = (refreshToken) => httpClient.post(GET_OTHER_SESSIONS, {refreshToken: refreshToken})

const getSessionInfo = () => httpClient.get(GET_SESSION_INFO)

const terminateOtherSessions = (refreshToken) => httpClient.post(TERMINATE_OTHER_SESSIONS, refreshToken)

const getFeatureFlag = () => httpClient.get(FEATURE_FLAG)

const editProfile = (otpCode) => httpClient.post(EDIT_PROFILE, {otpCode: otpCode})

const SendOtpRegisterByNationalId =(payload)=>httpClient.post(SEND_OTP_REGISTER_BY_NATIONAL_ID,
  {
    "nationalId": payload.nationalId,
    "scope": "user",
    "captchaKey": payload.captchaKey,
    "captchaValue": payload.captchaValue
  })

const ConfirmOtpRegisterByNationalId=(payload)=>httpClient.post(CONFIRM_OTP_REGISTER_BY_NATIONAL_ID,{
  "nationalId": payload.nationalId,
  "scope": "user",
  "confirmationCode": payload.confirmationCode
})

const ResendOtpRegisterByNationalId=(payload)=>httpClient.post(RESEND_OTP_REGISTER_BY_NATIONAL_ID,{
  "nationalId": payload.nationalId,
  "passportToken": payload.passportToken
})

const resendLoginOtp=(payload)=>httpClient.post(RESEND_LOGIN_OTP,{
  "phoneOrEmail": payload.phoneOrEmail,
  "nationalId": payload.nationalId,
  "passportToken": payload.passportToken
})

export {
  resendRegisterOtp,
  register,
  login,
  getUserInfo,
  postUserInfo,
  sendRegisterOtp,
  sendLoginOtp,
  confirmOtp,
  setNewPassword,
  getSuggestedPlanDescription,
  getPlan,
  resetPasswordOtp,
  resetPasswordConfirmOtp,
  resendResetPasswordOtp,
  resetPassword,
  changePassword,
  sendChangePasswordOtp,
  postFinancialUserInfo,
  postContactInfo,
  getProvinceList,
  getCityList,
  getUserContactInfo,
  getUserFinancialInfo,
  getUserDocuments,
  getImage,
  getAccountInfo,
  finishRegistration,
  requestPortfolio,
  getBanksList,
  getCaptcha,
  sendSejamOtp,
  saveSejamProfile,
  contactUs,
  citiesAutoComplete,
  getUserActionLog,
  getUserTicket,
  removeDocument,
  getTicket,
  sendTicket,
  getTicketCategories,
  sendTicketResponse,
  getTicketFile,
  sendTicketReplyResponse,
  getUserSettings,
  changeUserSettings,
  sendActionOtp,
  revokeToken,
  setDefaultFinancial,
  updateFinancialUserInfo,
  getAccountCaptcha,
  setUserPasswordAndBasicInfo,
  getUserAllInfo,
  getLicenseCaptcha,
  licenseOtp,
  confirmLicenseOtp,
  resendTwoFactorSms,
  checkUserRegistrationData,
  changeProfitType,
  sendChangeAccountSecurityOtp,
  changeAccountSecurity,
  logout,
  confirmLoginOtp,
  getCurrentSessions,
  getOtherSessions,
  terminateOtherSessions,
  getSessionInfo,
  getFeatureFlag,
  editProfile,
  SendOtpRegisterByNationalId,
  ConfirmOtpRegisterByNationalId,
  ResendOtpRegisterByNationalId,
  resendLoginOtp,

}
